import axios from 'axios'
import {
  URLS,
  URL,
  CLIENT_URL,
  SYNCFUSION_URL,
  REPORTS_URL,
  PAYMENT_URL,
  LEADS_URL
} from 'utils/constants'
import { getToken, logout, getTenant, getTenantUrl, isOnlyTimetracker } from './authService'
import { isTokenExpired } from './jwtHelper'

axios.interceptors.request.use(
  config => {
    const token = getToken()
    const tenant = getTenant(token)

    if (!config.headers.Authorization) {
      if (token) {
        config.headers.Authorization = `Bearer ${token}`
        if (tenant && !config.headers['x-tenant-schema']) {
          config.headers['x-tenant-schema'] = tenant
        }
      }
    }

    if (isTokenExpired(token)) {
      logout()
      window.location.href = URLS.LOGIN
    }

    return config
  },
  error => Promise.reject(error)
)

const getTenantBaseUrl = token => {
  const tenantUrl = getTenantUrl(token || getToken())
  if (!tenantUrl) return `${CLIENT_URL[process.env.ENV]}`

  return `https://${tenantUrl}`
}

export const getBaseUrl = url => {
  return `${URL[process.env.ENV]}${url}`
}

export const getSyncfusionBaseUrl = url => {
  return `${SYNCFUSION_URL[process.env.ENV]}${url}`
}

export const getReportsBaseUrl = url => {
  return `${REPORTS_URL[process.env.ENV]}${url}`
}

export const getLeadsBaseUrl = url => {
  return `${LEADS_URL[process.env.ENV]}${url}`
}

export const getRequest = url => {
  return axios.get(getBaseUrl(url)).then(response => response.data)
}

export const makeGetRequest = (url, params) => {
  return axios.get(getBaseUrl(url), params).then(response => response.data)
}

export const makeReportsGetRequest = (url, params) =>
  axios.get(getReportsBaseUrl(url), params).then(response => response.data)

export const makeLeadsGetRequest = (url, params) =>
  axios.get(getLeadsBaseUrl(url), params).then(response => response.data)

export const makePostRequest = (url, params, config = {}) =>
  axios.post(getBaseUrl(url), params, config).then(response => response.data)

export const makeReportsPostRequest = (url, params, config = {}) =>
  axios.post(getReportsBaseUrl(url), params, config).then(response => response.data)

export const makeLeadsPostRequest = (url, params, config = {}) =>
  axios.post(getLeadsBaseUrl(url), params, config).then(response => response.data)

export const getPaymentBaseUrl = url => {
  return `${PAYMENT_URL[process.env.ENV]}${url}`
}

export const makePaymentsGetRequest = (url, params) => {
  return axios.get(getPaymentBaseUrl(url), params).then(response => response.data)
}

export const makePaymentsPostRequest = (url, params, config = {}) =>
  axios.post(getPaymentBaseUrl(url), params, config).then(response => response.data)

export const makePutRequest = (url, params) =>
  axios.put(getBaseUrl(url), params).then(response => response.data)

export const makeLeadsPutRequest = (url, params) =>
  axios.put(getLeadsBaseUrl(url), params).then(response => response.data)

export const makeDeleteRequest = (url, params) =>
  axios.delete(getBaseUrl(url), params).then(response => response.data)

export const makeLeadsDeleteRequest = (url, params) =>
  axios.delete(getLeadsBaseUrl(url), params).then(response => response.data)

export const makePatchRequest = (url, params) =>
  axios.patch(getBaseUrl(url), params).then(response => response.data)

export const makeLeadsPatchRequest = (url, params) =>
  axios.patch(getLeadsBaseUrl(url), params).then(response => response.data)

export const loginRedirect = (navigate, token) => {
  if (process.env.NODE_ENV === 'production') {
    if (isOnlyTimetracker(token)) {
      window.location.href = getTenantBaseUrl(token) + URLS.AUTH_TIME_TRACKING
    } else {
      window.location.href = getTenantBaseUrl(token)
    }
  } else {
    if (isOnlyTimetracker(token)) {
      navigate(URLS.AUTH_TIME_TRACKING, { replace: true })
    } else {
      navigate(URLS.AUTH_HOME, { replace: true })
    }
  }
}
